import React, {useState} from "react";
import {useOutletContext} from "react-router";
import {useMediaQuery} from "@mui/material";
import Grid from "@mui/material/Grid";
import {RosterGrid} from "../components/grids/RosterGrid";
import {DropPlayerDialog} from "../components/dialogs/DropPlayerDialog";
import {apiPost, getUserName, rosterGridTypes} from "../utils";

export const DropContainer = () => {
    const {currentLeague, currentAuction, refreshLeagueMetadata} = useOutletContext();
    const [dropDialogOpen, setDropDialogOpen] = useState(false);
    const [dropRow, setDropRow] = useState({});

    const isMobile = useMediaQuery('(max-width: 780px)');

    const handleOpenDropDialog = (row) => {
        setDropRow(row);
        setDropDialogOpen(true);
    };

    const handleCloseDropDialog = () => {
        setDropDialogOpen(false);
    };

    const handleDropPlayer = () => {
        setDropDialogOpen(false);
        const dropPostBody = {
            playerYahooId: dropRow.yahoo_id,
            managerName: getUserName()
        }
        apiPost(`contract/drop${currentLeague.season_phase === 'PREDRAFT' ? '/predraft' : ''}`, dropPostBody, () => {
            refreshLeagueMetadata(); //TODO: is this actually correct here? ...why?
        });
    };

    const justify = isMobile ? 'flex-start' : 'center';
    return (
        <div style={{marginTop: 50}}>
            <Grid container justifyContent={justify}>
                <RosterGrid type={rosterGridTypes.ACTIONS} managerName={getUserName()}
                            seasonYear={currentAuction.season_year} weekNum={currentAuction.week_num}
                            onDropButtonClick={handleOpenDropDialog}/>
                <DropPlayerDialog open={dropDialogOpen} handleClose={handleCloseDropDialog} dropRow={dropRow}
                                  handleDropPlayer={handleDropPlayer}/>
            </Grid>
        </div>
    );
}